import { Button } from "@/components/ui/button/button";

type Props = {
	onUpdatePlanStock: () => void;
	isValid: boolean;
	isDirty: boolean;
};

export const HeaderUpdateButton = ({ onUpdatePlanStock, isValid, isDirty }: Props) => {
	return (
		<Button variant={isValid && isDirty ? "default" : "disabled"} size={"xl"} onClick={onUpdatePlanStock}>
			保存
		</Button>
	);
};
